<template>
  <section id="section_loader">
    <vs-button color="primary" type="filled" icon="attachment">
      Cargar archivo
    </vs-button>
  </section>
</template>

<script>
export default {
  name: "DiscountsLoader",
  components: {},
  data: () => ({}),
  watch: {},
  mounted() {},
  methods: {},
};
</script>
